import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import PreventivoDialog from "./PreventivoDialog";

const PreventivoContext = createContext({ openPreventivo: () => {} });

export const usePreventivo = () => useContext(PreventivoContext);

export const PreventivoProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [engine, setEngine] = useState(null);
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL || ""}/catalogo.json`)
      .then((r) => r.json())
      .then((d) => setCatalog(d))
      .catch(() => {});
  }, []);

  const openPreventivo = useCallback((eng = null) => {
    setEngine(eng);
    setOpen(true);
  }, []);

  return (
    <PreventivoContext.Provider value={{ openPreventivo }}>
      {children}
      <PreventivoDialog engine={engine} open={open} onClose={() => setOpen(false)} catalog={catalog} />
    </PreventivoContext.Provider>
  );
};

export default PreventivoContext;
